module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_8023.58a9ce5d.png";